export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/sale-icon.f4323ed9.svg","height":10,"width":10,"blurWidth":0,"blurHeight":0};